<template>
	<div class="row justify-content-center mt-3">
		<div class="col-8 text-center mb-2">
			<b-button
					class="w-100"
					@click="createRequestJob()"
					:disabled="requestJob != null"
					size="sm"
			>
				{{ requestJob == null ? 'Metadaten neu anfordern' : 'Anfrage läuft' }}
			</b-button>
		</div>

		<div class="col-12 d-flex justify-content-between text-dark">
    <span
				v-if="formattedReleaseDate != null && formattedReleaseDate !== ''"
		>
      ReleaseDate: {{ formattedReleaseDate }}
    </span>

			<span
					v-if="formattedLastSuccessfulMetaDataRequest != null && formattedLastSuccessfulMetaDataRequest !== ''"
			>
      MD-Anfrage: {{ formattedLastSuccessfulMetaDataRequest }}
    </span>
		</div>

		<div v-if="passedUser?.role ==='dev' " class="mt-2">
				<b-form-textarea :value="computedSetFlags" rows="10" style="width: 450px; white-space: pre-line;" disabled />
		</div>
	</div>
	<modal-error-component v-model="modalError"></modal-error-component>
</template>

<script>
import ModalErrorComponent from "../../ModalErrorComponent.vue";

export default {
	name: "MetaDataActions",
	components: {ModalErrorComponent},
	props:{
		passedMaterial: {
			type: Object,
			required: true
		},
		passedUser: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			requestJob: null,
			formattedReleaseDate: null,
			productFLags: {
				FSK_18: 1n,
				DHL_KLEINPAKET: 2n,            //Sendungsart
				VINYL: 4n,
				BULKY_GOOD: 8n,
				POWER_PLUG: 16n,
				VENDOR_WEIGHT_AMBIGUOUS: 32n,
				VENDOR_WEIGHT_WELTRECORDS: 64n,
				LIQUID: 128n,
				AMIIBO: 256n,            //Versandaufschlag
				SKYLANDERS: 512n,
				FUNKO: 1024n,
				SPRING_PARCEL_US: 2048n,
				CALENDAR: 4096n,
				PARROT: 8192n,
				NINTENDO_GAME: 16384n,
				LITHIUM_BATTERY: 32768n,
				MANUAL_PACKAGE_DIMENSIONS: 65536n,
				POST_NL_LETTERBOX_PLUS: 131072n,
				CLAIREFONTAINE: 262144n,
				TPLINK: 524288n,
				MOLESKINE: 1048576n,
				NETGEAR: 2097152n,
				PALADONE: 4194304n,
				OVERSIZED_SPRING: 8388608n,
				CATEGORY_MANUALLY_SET: 16777216n,
				FRAGILE: 33554432n,
				DP_LETTER: 67108864n,
				DP_WARENPOST_DE: 134217728n,
				DP_WARENPOST_INT: 268435456n,
				SPRING_LETTER: 536870912n,
				SPRING_BOXABLE: 1073741824n,
				SHAPE_IRREGULARITY: 2147483648n,
				TRAY: 4294967296n,
				SHIPPING_WEIGHT_TYPE_MARKET: 0,
				SHIPPING_WEIGHT_TYPE_VENDOR: 1,
				SHIPPING_WEIGHT_TYPE_DEFAULT:2,
				SHIPPING_WEIGHT_TYPE_MANUAL: 3,
			},
			modalError: {
				show: false,
				message: 'Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden.',
				error: '',
				title: ''
			}
		}
	},
	computed: {
		formattedLastSuccessfulMetaDataRequest() {
			if(this.passedMaterial.product.lastSuccessfulMetaDataRequest) {
				return moment(this.passedMaterial.product.lastSuccessfulMetaDataRequest).format("DD.MM.YYYY");
			}
			return "-";
		},
		// for debugging -- so see all set flags
		computedSetFlags() {
			if (!this.passedMaterial.product) return '';

			const flags = Object.entries(this.productFLags)
					.filter(([_, flagValue]) => {
						const currentFlags = BigInt(this.passedMaterial.product.flags ?? 0);
						const bit = BigInt(flagValue);

						return (currentFlags & bit) === bit; })
					.map(([flagKey]) => flagKey)
					.join('\n');

			const flagOverrides = Object.entries(this.productFLags)
					.filter(([_, flagValue]) => {
							const currentFlags = BigInt(this.passedMaterial.product.flagOverrides ?? 0);
							const bit = BigInt(flagValue);

							return (currentFlags & bit) === bit;
						})
					.map(([flagKey]) => flagKey)
					.join('\n');

			return flags + '\n\n------ flagOverrides ------\n' + flagOverrides;
		}
	},
	methods: {
		createRequestJob()
		{
			let requestJob = {
				identifier: this.passedMaterial.asin,
				identifierType: 'asin',
				type: 'update',
				state: 'created',
				doneAt: null,
				productId: this.passedMaterial.product.id
			};
			// console.log(requestJob);
			axios.post('/mds/request_job', requestJob).then( response => {
				this.requestJob = response.data;
			}).catch( error => {
				console.error(error);
				alert("Netzwerkfehler");
			});
		},
		getRequestJob(){
			let payload = {
				identifier: this.passedMaterial.product.asin,
				identifierType: 'asin'
			};

			// get request_job status for product
			axios.post('/mds/request_job/open/by_identifier', payload).then( response => {
				if(response.data.length === 1) {
					this.requestJob = response.data;
				}else if( response.data.length > 1) {
					alert("Achtung: zu diesem Artikel gibt es mehrere Request Jobs. Bitte Umgehend Devs melden.");
				}else{
					this.requestJob = null;
				}
			}).catch( error => {
				alert("Netzwerkfehler");
				console.log('get open requestJobs failed: ');
				console.log(error);
			});
		},
		formatReleaseDate()
		{
			//"Because of the variances in parsing of date strings, it is recommended to always manually parse strings as results are inconsistent, ..."
			// assumes format: YYYY-MM-DD

			if (this.passedMaterial.product.releaseDate === null || this.passedMaterial.product.releaseDate === "") return;

			let year = this.passedMaterial.product.releaseDate.substr(0,4);
			let month = this.passedMaterial.product.releaseDate.substr(5,2);
			let day = this.passedMaterial.product.releaseDate.substr(8,2);
			this.formattedReleaseDate = day + '.' + month + '.' + year;
		},
	},
	created() {
		this.getRequestJob();
	},
	mounted() {
		this.formatReleaseDate();
	}
}
</script>

<style scoped>

</style>